export default __webpack_public_path__ + "static/reduce-risk-d7baf4752f228a3eb69bfc3b687fa002.png";